module.exports = __webpack_public_path__ + "img/360.c9696f2f.svg";